import { useEffect, useState } from 'preact/hooks';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Hook which subscribes to the observable and returns last value.
 */
export function useObservable<T>(observable$: BehaviorSubject<T>): T;
export function useObservable<T>(observable$: Observable<T>): T | undefined;
export function useObservable<T>(observable$: Observable<T> | BehaviorSubject<T>): T | undefined {
    const [value, setValue] = useState<T>(observable$ instanceof BehaviorSubject ? observable$.value : undefined);
    useEffect(() => {
        const sub = observable$.subscribe((value) => {
            setValue(value);
        });
        return () => sub.unsubscribe();
    }, [observable$]);
    return value;
}
